const ReportStatus = {
    0: 'No Report',
    1: 'Drafted',
    2: 'Admitted',
    3: 'Typed',
    4: 'Accepted',
    5: 'Verified',
    6: 'Sent To His',
    7: 'Sent To Patient',
};

const ReportStatusTranslatable = {
    0: 'no_report',
    1: 'drafted',
    2: 'admitted',
    3: 'typed',
    4: 'accepted',
    5: 'verified',
    6: 'sent_to_his',
    7: 'sent_to_patient',
};

export {ReportStatus, ReportStatusTranslatable};

export const REPORT_STATUS_EMPTY = 0;
export const REPORT_STATUS_DRAFT = 1;
export const REPORT_STATUS_ADMITTED = 2;
export const REPORT_STATUS_TYPED = 3;
export const REPORT_STATUS_FIRST_ACCEPTED = 4;
export const REPORT_STATUS_ACCEPTED = 4;
export const REPORT_STATUS_FINAL_ACCEPTED = 5;
export const REPORT_STATUS_VERIFIED = 5;
export const REPORT_STATUS_SENT_TO_HIS = 6;
export const REPORT_STATUS_SENT_TO_PATIENT = 7;
